var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.P_customClass},[_c(_vm.DV_componentType,{tag:"component"},[_vm._v(_vm._s(_vm.P_customCss))]),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.C_isVisible),expression:"C_isVisible"}],style:(_vm.textStyle)},[_vm._v(_vm._s(_vm.P_text))])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4ba4c88","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Grid/GText.vue
// module id = null
// module chunks = 